import React from "react";
//import Style from './Topbar.scss'
// import {ReactComponent as HomelaneLogo} from '../../assets/icons/homelane.svg'
import homelaneLogo from '../../assets/icons/homelane.png'
import doowupLogo from '../../assets/icons/doowup.png'
import { connect } from "react-redux";
import {getPlanOverViewData, setRoomName} from '../../actions/wizard';
import {ReactComponent as WrapzapLogo} from '../../assets/icons/wrapzapLogo.svg';
import {ReactComponent as CubicoLogo} from '../../assets/icons/cubicoLogo.svg';
import {ReactComponent as DesignCafeLogo } from '../../assets/icons/designCafeLogo.svg';
import {ReactComponent as BrigadeLogo } from '../../assets/icons/brigadeLogo.svg';
import { isBrigadeProfile } from '../../utils/profile';

class UpperRailComponent extends React.Component<any, any>{
    constructor(props){
        super(props);
        this.state={
            selectedRoomId: ""
        }
    }
    componentDidMount(){
        let {roomInfoList} = this.props;
        if(roomInfoList && roomInfoList.length>0){
            this.setState({
                selectedRoomId: roomInfoList[0].roomId
            })
        }
    }
    handleRoomChange = (e)=>{
        try {
            let {roomInfoList, projectData} = this.props;
            let {opportunityId} = projectData;
            let value = e.target.value;
            if(!value)
                return;
            let roomObj = roomInfoList.filter(room=> {
                let name=room.roomName.trim().toLowerCase().replace(/\s+/g, '');
                let selectedRoom=value.trim().toLowerCase().replace(/\s+/g, '');
                return (name === selectedRoom);
            });
            let {roomId, roomName} = roomObj[0];
            this.props.getPlanOverViewData({roomId, projectData});
            this.props.setRoomName(roomName);
            this.setState({
                selectedRoomId: value
            });
            window.history.pushState({}, null, `/${opportunityId}/${roomId}${isBrigadeProfile() ? '/brigade' : ''}`);
            //window.location.replace(url);
        } catch (error) {
            console.error("Error in handleRoomChange", error);
        }
    }
    render(){
        console.log('room info', this.props);
        const {roomInfoList, projectData, roomName,orderProfileType} = this.props;
        const {customer_details} = projectData || {};
        const {Customer_Name, displayProfile} = customer_details || "";
        
        return(
            <div className={'upperRail'}>
                <div className={'left'}>
                    {
                       orderProfileType ? ( orderProfileType ==='DOOWUP' ? <img  src={doowupLogo} alt="Logo" className={'hlLogo'}/> :  orderProfileType === 'WRAPZAP' ? <WrapzapLogo /> : displayProfile?.toLowerCase() === 'cubico' ? <CubicoLogo className={'hlLogo'} /> : ['dc', 'designcafe'].includes(orderProfileType?.toLowerCase()) ? <DesignCafeLogo /> : orderProfileType === 'BRIGADE' ? <BrigadeLogo className={'hlLogo'} /> : <img  alt="Logo" src={homelaneLogo} className={'hlLogo'}/>): ""
                    }
                    {/* <HomelaneLogo className={'hlLogo'} /> */}
                    <div className={'projectData'}>
                        <span>2D DRAWING WIZARD</span>
                        {' '}
                    </div>
                    <div className="roomDropDown">
                            <span>{`Mr. ${Customer_Name}`}</span>
                            <select className="dropdown" onChange={(e)=> this.handleRoomChange(e)}>
                               {
                                   roomInfoList && roomInfoList.length && roomInfoList.map(roomObj=>{
                                        return(
                                            <option selected={roomName?.trim() === roomObj.roomName?.trim()} key={roomObj.roomId} data-room-id={roomObj.roomId}>{roomObj.roomName}</option>
                                        )
                                   })
                               }
                            </select>
                        </div>
                </div>

            </div>
        )
    }

}
export default connect(
    (state: any) => ({
        roomInfoList: state.wizard.roomInfoList,
        projectData: state.wizard.projectData,
        roomName: state.wizard.roomName,
        orderProfileType: state.wizard.orderProfileType
    }),
    {
        getPlanOverViewData,
        setRoomName
    }
)(UpperRailComponent); 